

























































































import Component, { mixins } from 'vue-class-component'
import Card from '@/components/Card.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { ESortOrder, EUserPermissions } from '@zunta/configurations'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import { User } from '@/classes/User'
import Api from '@/api'
import ScrollView from '@/components/ScrollView.vue'
import Icon from '@/components/Icon.vue'
import NoData from '@/views/app/management/residents/NoData.vue'
import { ResidentPageMixin } from '@/views/app/management/residents/resident-page/ResidentPageMixin'

@Component({
  components: { NoData, Icon, ScrollView, LoaderWrapper, DateTimeLabel, Card }
})
export default class ResidentHistoryWidget extends mixins(ResidentPageMixin) {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  user: User = Api.getUser() as User
  isLoading: boolean = false
  historyNote: string = ''

  get residentId () {
    return this.$route.params.id
  }

  get collectionsHistory () {
    return this.$store.state.resident.collectionHistory
  }

  get lastNotes () {
    if (!this.collectionsHistory || !this.collectionsHistory.length) {
      return null
    }
    return this.collectionsHistory.reverse()
  }

  mounted () {
    this.fetchData()
    this.$watch('residentId', () => this.fetchData())
  }

  async fetchData () {
    try {
      this.isLoading = true
      this.historyNote = ''
      await this.residentModuleInstance.fetchResidentHistoryByFilters({
        residentId: this.residentId,
        filters: {
          sortBy: 'date',
          sortOrder: ESortOrder.DESC,
          skip: 0,
          limit: 10
        }
      })
    } finally {
      this.isLoading = false
      this.scrollToBottomOfTheHistory()
    }
  }

  async addNote () {
    if (!this.user.hasPermissionFor(EUserPermissions.ADD_HISTORY_NOTE)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Add History Note`,
        icon: 'warning'
      })
      return
    }

    if (!this.historyNote) {
      return
    }

    try {
      this.isLoading = true
      await this.residentModuleInstance.addResidentHistoryNote({
        residentId: this.residentId,
        data: {
          user: this.user.data.id,
          note: this.historyNote
        }
      })
      this.historyNote = ''
      await this.fetchData()
    } finally {
      this.isLoading = false
    }
  }

  scrollToBottomOfTheHistory () {
    this.$nextTick(() => {
      const el = document.querySelector('#collection-history-widget .scroll-area')
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    })
  }
}
